import React from "react";
import '../assets/css/progressbar.css'

function ProgressBar(props) {

  let isText2Visible = false;
  let isText3Visible = false;
  let isText4Visible = false;

  let Current = props.current;
  if (Current === 2) {
    isText2Visible = true;
  }
  else if (Current === 3) {
    isText2Visible = true;
    isText3Visible = true;
  }
  else if (Current === 4) {
    isText2Visible = true;
    isText3Visible = true;
    isText4Visible = true;
  }
  else {
    isText2Visible = false;
    isText3Visible = false;
    isText4Visible = false;
  }
  return (
    <>
      <div class="container-fluid">
        <form id="msform">
          <ul id="progressbar">
            <li className="active" id="text1"><strong>ورود اطلاعات </strong></li>
            <li className={`${isText2Visible ? "active" : ""}`} id="text2"><strong>تایید اطلاعات</strong></li>
            <li className={`${isText3Visible ? "active" : ""}`} id="text3"><strong>پرداخت با کارت </strong></li>
            <li className={`${isText4Visible ? "active" : ""}`} id="text4"><strong>تایید پرداخت</strong></li>
          </ul>
        </form>
      </div>

    </>
  );
}

export default ProgressBar;